<template>
  <div class="mywatch">
    <Header></Header>
    <div v-if="childInfo.length>0">
      <div>
        <div class="title">已绑定手表</div>
        <div class="child-area bg-white">
          <div class="child-area-item" v-for="(item,index) in childInfo" :key="index">
            <div>
              <div class="child-area-row">
                昵称：
                <span v-if="editIndex!=index">{{item.name}}</span>
                <!-- <img @click="editName(index)" v-if="editIndex!=index" src="../assets/images/edit.png" /> -->
                <input
                  class="edit-input color999"
                  @keyup.enter="submitEdit(index)"
                  :ref="'editName'+index"
                  v-else
                  placeholder="请输入..."
                />
              </div>
              <!-- <div class="child-area-row">手表id：{{item.watchOpenId}}</div> -->
              <div class="child-area-row color-grey">已绑定</div>
            </div>
            <!-- <div class="btn-unbind" @click="unbind(item.id,index)">解除绑定</div> -->
          </div>
          <!-- <div style="text-align:center">
            <van-button color="#87E2CD" class="bg-green colorfff btn-scan" type="primary" @click="bind">扫码添加手表</van-button>
          </div> -->
        </div>
      </div>
    </div>
    <div v-else>
      <div>
        <div class="title">未绑定手表</div>
        <div class="child-area bg-white">
          <div>请扫码绑定您孩子的手表，查看和定制符合您孩子发展的任务哦～</div>
          <!-- <div style="display:flex;justify-content:center">
            <van-button color="#87E2CD" class="bg-green colorfff btn-scan" type="primary" @click="bind">扫码添加手表</van-button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {updateName,listByParentId} from "../api/api-child";
import { Dialog } from 'vant';
import Header from "../components/Header";
export default {
  name: "myWatch",
  components: {
    Header
  },
  data() {
    return {
      showData: false,
      // childInfo:[],
      editIndex: -1
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      childInfo: state => state.childInfo,
      activeChildInfo: state => state.activeChildInfo
    })
  },
  watch: {},
  methods: {   
    editName(idx) {
      this.editIndex = idx;
    },
    submitEdit(idx) {      
      let params = {
        id: this.childInfo[idx].id,
        name: this.$refs['editName'+idx][0].value
      };
      updateName(params).then(res=>{
        if(res.code==200){
          this.editIndex=-1;
          this.childInfo[idx].name=this.$refs['editName'+idx][0].value;
          this.$store.dispatch('setChildInfo',this.childInfo)
        }
      })
    },
    unbind(id,idx) {
      var that = this;
  Dialog.confirm({
  title: '提示',
  message: '确认解除绑定吗'
}).then(() => {
  
}).catch(() => {
  // on cancel
})
    },
    bind() {
      var that = this;
      wx.scanCode({
        success(res) {
          api.bind(JSON.parse(res.result)).then(res => {
            if (res.data.code == 200) {
              that.setData({ editIndex: -1 });
              that.getChildInfo();
            } else {
              wx.showToast({
                title: res.data.msg,
                icon: "none"
              });
            }
          });
        }
      });
    }
  },
  created() {},
  mounted() {}
};
</script>
<style scoped lang="less">
.mywatch{
    height: 100vh;
    background: #ECF0F5;
}
.title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  padding: 15px;
}
.child-area {
  padding: 15px;
}
.child-area-item {
  padding-top: 12px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eeeeee;
  padding-left: 15px;
}
.child-area-item>div:first-of-type{
  width: 60%;
  .child-area-row{
    display: flex;
    align-items: center;
    white-space:nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    &:first-child{
      height: 23px;
    }
  }
}
.btn-unbind {
  width: 100px;
  height: 28px;
  border-radius: 22px;
  border: 1px solid rgba(135, 226, 203, 1);
  line-height: 28px;
  color: #87e2cb;
  text-align: center;
}
.child-area-row {
  margin-bottom: 8px;
}
.child-area-row img {
  width: 15px;
  height: 15px;
  margin-left: 10px;
}
.edit-input {
  width: 100px;
  display: inline-block;
  vertical-align: top;
  border: none;
  height: 100%;
}
.btn-scan {
  width: 150px;
  color: #fff;
  font-size: 16px;
  border-radius: 22px;
  text-align: center;
  margin-top: 20px;
}
.btn-scan::after {
  border: none;
}
</style>